import { Link } from 'react-router-dom';
import { Typography } from '@mui/material';
import toList from '../utils/ComponentUtil';
import CustomBreadcrumbs from '../utils/CustomBreadcrumbs';
import Header from '../utils/Header';
import CustomSearchBar from '../utils/CustomSearchBar';
import SearchCards from '../utils/SearchCards';
import PaymentProofCard from './PaymentProofCard';
import PaymentProofAPI from '../Apis/PaymentProofAPI';

function PaymentProofs() {
    const breadcrumbs = [toList([{ to: "/", child: "Home" }], Link)
        , <Typography className="job-page-name">Payment Proof</Typography>]

    return (
        <>
            <SearchCards
                card={PaymentProofCard}
                api={PaymentProofAPI.fetchProofs}
                heading={<div className='wrapper'><CustomBreadcrumbs breadcrumbs={breadcrumbs} />
                    <Header title='Payment Proof'></Header>
                    <CustomSearchBar placeholder='Search by names' /></div>}
            />
        </>
    );
}

export default PaymentProofs;